/* eslint-disable no-unused-vars */
import React, { useState } from "react";
/* import Spacer from "../common/Spacer"; */
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ContactForm from "./ContactForm";
import ContactThree from "./ContactThree";
import ContactMap from "./ContactMap";
import { SRLWrapper } from "simple-react-lightbox";
import data from "../../data/product.json";
import Spacer2 from "../common/Spacer2";
import Spacer3 from "../common/Spacer3";

function Contact() {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  const toggleNav = () => {
    setExpanded(!expanded);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
    setExpanded(false);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
    setExpanded(false);
  };

  

  return (
    <>
      {/* <section class="product-one section-space-top pt-0 pb-0" >
          <div class="container">
            <div class="sec-title sec-title--center">
              <img
                src="assets/images/favicons/favicon-32x32.webp"
                alt="featured products"
                class="sec-title__img"
              />
              <h6 class="sec-title__tagline">Seymen Kimya</h6>
              <h2 class="sec-title__title">İletişim</h2>
              <Spacer3/>
            </div>
          </div>
        </section> */}
      <ContactForm />
      <ContactThree />
      <ContactMap />
    </>
  );
}

export default Contact;
